export const OPPORTUNITY = 'opportunity';
